export const PRACTICES_PATH = "/practices";
export const PRACTICE_RECORDS_PATH = `${PRACTICES_PATH}/records`;

export function practiceRecordsPath(search = ""): string {
  return `${PRACTICE_RECORDS_PATH}${search}`;
}

/** Preserve legacy CRM bookmarks while moving the registration directory. */
export function practicesRedirectFromCrm(search: URLSearchParams): string {
  const next = new URLSearchParams(search);
  if (!next.has("approval")) next.set("approval", "all");
  const query = next.toString();
  return `${PRACTICES_PATH}${query ? `?${query}` : ""}`;
}

/** Route old canonical-directory bookmarks to their new secondary location. */
export function legacyPracticeRecordsPath(search: URLSearchParams): string | null {
  if (search.has("approval")) return null;
  if (!["name", "status", "cursor"].some((key) => search.has(key))) return null;
  const query = search.toString();
  return practiceRecordsPath(query ? `?${query}` : "");
}

export function practicePath(id: string, search = ""): string {
  return `${PRACTICES_PATH}/${encodeURIComponent(id)}${search}`;
}

export interface PracticeCursor {
  normalizedLegalName: string;
  id: string;
}

/** Cursor history travels with the URL so details and browser Back retain the directory. */
export function practiceSearchState(search: URLSearchParams) {
  const name = search.get("name")?.trim() ?? "";
  const rawStatus = search.get("status");
  const status: "active" | "prospect" | "inactive" | "" = rawStatus === "active" || rawStatus === "prospect" || rawStatus === "inactive" ? rawStatus : "";
  const cursors: PracticeCursor[] = [];
  for (const raw of search.getAll("cursor")) {
    try {
      const cursor: unknown = JSON.parse(raw);
      if (!cursor || typeof cursor !== "object" || !("normalizedLegalName" in cursor) || !("id" in cursor)
        || typeof cursor.normalizedLegalName !== "string" || !cursor.normalizedLegalName
        || typeof cursor.id !== "string" || !cursor.id) break;
      cursors.push({ normalizedLegalName: cursor.normalizedLegalName, id: cursor.id });
    } catch {
      break;
    }
  }
  return { name, status, cursors };
}

export function practiceSearchParams(name: string, status: string, cursors: PracticeCursor[] = []): URLSearchParams {
  const search = new URLSearchParams();
  if (name.trim()) search.set("name", name.trim());
  if (status) search.set("status", status);
  for (const cursor of cursors) search.append("cursor", JSON.stringify(cursor));
  return search;
}

export function practicesApiPath(input: {
  limit: number;
  name?: string;
  status?: string;
  afterName?: string;
  afterId?: string;
}): string {
  const query = new URLSearchParams({ limit: String(input.limit) });
  if (input.name?.trim()) query.set("name", input.name.trim());
  if (input.status) query.set("status", input.status);
  if (input.afterName && input.afterId) {
    query.set("afterName", input.afterName);
    query.set("afterId", input.afterId);
  }
  return `/practices?${query.toString()}`;
}
